import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from '../../../../axiosConfig';
import LatestDevelopments from './LatestDevelopments';
import styles from '../../MicroProbe/MicroProbe.module.css';
import IdeasMaker from '../../IdeasMaker';
import TopicGather from '../../TopicGather';
import SentimentTrend from './SentimentTrend';
import Networks from './Networks';
import ChatNumbers from './ChatNumbers';
import PriceData from './PriceData';
import PriceDataIntraday from './PriceDataIntraday';  
import PerformanceOverview from './PerformanceOverview';
import SignalsBacktestTechnicalsPlot from './SignalsBacktestTechnicalsPlot';
import SignalsBacktestTechnicals from './SignalsBacktestTechnicals';
import SignalsBacktestAI from './SignalsBacktestAI';
import SignalsBacktestTechnicalsCurrencyPairs from './SignalsBacktestTechnicalsCurrencyPairs';
import RegulationHighlight from './RegulationHighlight';
import VideoInsight from '../../MicroProbe/Companies/VideoInsightForDashboard';
import DocumentUploads from '../../MicroProbe/Companies/MicroProbeDocuments';

const IndividualCrypto = () => {
  const { cryptoName } = useParams();
  const [inputData, setInputData] = useState(null);
  const [expandedSections, setExpandedSections] = useState(new Set()); // Track multiple expanded sections
  
  useEffect(() => {
    const fetchInputData = async () => {
      try {
        const response = await axios.get(`/api/crypto/name/${cryptoName}`);
        setInputData(response.data);

      } catch (error) {
        console.error('Error fetching currency data:', error);
      }
    };
  
    fetchInputData();
  }, [cryptoName]);

  const toggleSection = (sectionId) => {
    setExpandedSections(prev => {
      const newSet = new Set(prev);
      if (newSet.has(sectionId)) {
        newSet.delete(sectionId);
      } else {
        newSet.add(sectionId);
      }
      return newSet;
    });
  };

return (
  <div className={styles.container}>
    <h1 className={styles.title}>Cryptocurrency: {cryptoName}</h1>

    {inputData && (
      <>  
        {/* Latest Developments Section */}
        <div className={styles.collapsibleSection}>
          <button 
            className={styles.sectionHeader}
            onClick={() => toggleSection('overview')}
          >
            <h2>Latest Developments</h2>
            <span className={`${styles.arrow} ${expandedSections.has('overview') ? styles.open : ''}`}>›</span>
          </button>
          <div style={{ display: expandedSections.has('overview') ? 'block' : 'none' }}>
            <div className={`${styles.section} ${styles.sectionBg1}`}>
              <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>
                <LatestDevelopments  inputData={inputData} />
              </div>
            </div>

            <div className={`${styles.section} ${styles.sectionQuarter} ${styles.sectionBg2}`}>
              <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>
                <SentimentTrend  inputData={inputData} />
              </div>

              <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>
                <Networks  inputData={inputData} />
              </div>   
            </div>
          </div>
        </div>

        {/* Regulation Updates Section */}
        <div className={styles.collapsibleSection}>
          <button 
            className={styles.sectionHeader}
            onClick={() => toggleSection('regulation')}
          >
            <h2>Regulation Updates</h2>
            <span className={`${styles.arrow} ${expandedSections.has('regulation') ? styles.open : ''}`}>›</span>
          </button>
          <div style={{ display: expandedSections.has('regulation') ? 'block' : 'none' }}>
            <div className={`${styles.section} ${styles.sectionBg1}`}>
              <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>
                <RegulationHighlight inputData={inputData} />
              </div>
            </div>
          </div>
        </div>

        {/* Performance Section */}
        <div className={styles.collapsibleSection}>
          <button 
            className={styles.sectionHeader}
            onClick={() => toggleSection('performance')}
          >
            <h2>Performance</h2>
            <span className={`${styles.arrow} ${expandedSections.has('performance') ? styles.open : ''}`}>›</span>
          </button>
          <div style={{ display: expandedSections.has('performance') ? 'block' : 'none' }}>
            <div className={`${styles.section} ${styles.sectionBg3}`}>
              <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>
                <PerformanceOverview  inputData={inputData} />
              </div>
            </div>

            <div className={`${styles.section} ${styles.sectionBg3}`}>
              <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>
                <PriceDataIntraday inputData={inputData} />
              </div>
            </div>

            <div className={`${styles.section} ${styles.sectionBg3}`}>
              <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>
                <PriceData inputData={inputData} />
              </div>
            </div>

            <div className={`${styles.section} ${styles.sectionBg3}`}>
              <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>
                <ChatNumbers inputData={inputData} />
              </div>
            </div>
          </div>
        </div>

        {/* Risk and Signals Section */}
        <div className={styles.collapsibleSection}>
          <button 
            className={styles.sectionHeader}
            onClick={() => toggleSection('signals')}
          >
            <h2>Risks & Signals</h2>
            <span className={`${styles.arrow} ${expandedSections.has('signals') ? styles.open : ''}`}>›</span>
          </button>
          <div style={{ display: expandedSections.has('signals') ? 'block' : 'none' }}>
            <div className={`${styles.section} ${styles.sectionBg5}`}>
              <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>
                <SignalsBacktestAI inputData={inputData} />
              </div>
            </div>

            <div className={`${styles.section} ${styles.sectionQuarter} ${styles.sectionBg5}`}>
              <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>
                <SignalsBacktestTechnicals inputData={inputData} />
              </div>
              <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>
                <SignalsBacktestTechnicalsPlot inputData={inputData} />
              </div>
            </div>

            <div className={`${styles.section} ${styles.sectionBg5}`}>
              <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>
                <SignalsBacktestTechnicalsCurrencyPairs inputData={inputData} />
              </div>
            </div>
          </div>
        </div>

        {/* Documents and Media Section */}
        <div className={styles.collapsibleSection}>
          <button 
            className={styles.sectionHeader}
            onClick={() => toggleSection('documents')}
          >
            <h2>Documents & Media</h2>
            <span className={`${styles.arrow} ${expandedSections.has('documents') ? styles.open : ''}`}>›</span>
          </button>
          <div style={{ display: expandedSections.has('documents') ? 'block' : 'none' }}>
            <div className={`${styles.section} ${styles.sectionBg4}`}>
              <div className={styles.sectionContent} style={{ width: '100%', height: 'auto'}}> 
                <TopicGather />
              </div>
            </div>

            <div className={`${styles.section} ${styles.sectionBg4}`}>
              <div className={styles.sectionContent} style={{ width: '100%', height: 'auto'}}> 
                <DocumentUploads />
              </div>
            </div>
            
            <div className={`${styles.section} ${styles.sectionBg4}`}>
              <div className={styles.sectionContent} style={{ width: '100%', height: 'auto'}}>
                <VideoInsight />
              </div>
            </div>
          </div>
        </div>


        {/* Report Section */}
        <div className={styles.collapsibleSection}>
          <button 
            className={styles.sectionHeader}
            onClick={() => toggleSection('report')}
          >
            <h2>Reports</h2>
            <span className={`${styles.arrow} ${expandedSections.has('report') ? styles.open : ''}`}>›</span>
          </button>
          <div style={{ display: expandedSections.has('report') ? 'block' : 'none' }}>
            <div className={`${styles.section} ${styles.sectionQuarter} ${styles.sectionBg6}`}>
              <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>   
                <IdeasMaker/>
              </div>
            </div>
          </div>
        </div>


      </>
    )}

    <Link to="/entity-intelligence">Back</Link>
  </div>
);
};

export default IndividualCrypto;